import { render, staticRenderFns } from "./buycar.vue?vue&type=template&id=cdd657d2&scoped=true&"
import script from "./buycar.vue?vue&type=script&lang=js&"
export * from "./buycar.vue?vue&type=script&lang=js&"
import style0 from "./buycar.vue?vue&type=style&index=0&id=cdd657d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd657d2",
  null
  
)

component.options.__file = "buycar.vue"
export default component.exports